/*
创建者 魏强(2018.3.5)
*/
<template>
<div class="header-wrap">
	<header class="public-head-layout wrapper" style="width:1200px">
		<!--LOGO-->
		<div class="site-logo index_logo">
			<router-link :to="{path:'/shop',query:{tab:1,store_id:1}}">
				<img :src="slogo" class="pngFix">
      </router-link>
		</div>
		<div class="head-search-bar" id="search">
			<div class="search-form">
				<input name="namekeyword" v-model="keywords" id="namekeyword" type="text" class="input-text" value=""  maxlength="60"/>
				<input type="button" id="inquiry" value="搜索" class="input-submit" @click="searchBtn" />
			</div>
		</div>
	</header>
</div>
</template>
<script>
import slogo from '../../../assets/images/selling/logo.png';
  export default {
    data(){
      return {
      	slogo,
      	keywords:''
      }
    },
    mounted(){

    },
    computed: {

    },
    methods: {
		searchBtn(){
	        let keywords =this.keywords;
	        if(!keywords){
	          this.$Message.destroy();
	          this.$Message.info('请输入关键字');
	          return false;
	        }
	        let url = { path: '/goods-list', query: { keywords: keywords }}
	        this.$router.push( url );
	    }

    }
  }
</script>
<style lang="less">
</style>



// WEBPACK FOOTER //
// header.vue?02a1a03c